<template>
  <div
    class="quiz-header-inner__title"
    :class="{'items-center mb-5': isModalContent}"
  >
    <div
      class="back-search"
      :class="{'text-center justify-center': isModalContent && !isSearchAIModalContentVisible}"
    >
      <span v-show="isArrowBackVisible" class="back-arrow__wrapper" @click.stop="backToChooseSlideType">
        <i class="fas fa-chevron-left"></i>
        <span class="back-arrow__background"></span>
      </span>
      <span
        v-if="isGeneratorContentVisible"
        class="quiz-header-inner__title-text"
      >{{ $i18nPresenter.t('AI Slides Generator') }}</span>
      <span v-else class="quiz-header-inner__title-no-prompt">{{ $i18nPresenter.t('AI Slides Generator') }}</span>
      <aha-icon
        v-if="!isGeneratorContentVisible || isModalContent"
        name="sparkles-white"
        class="quiz-header-inner__title-icon"
      />
    </div>
    <slot name="title"></slot>
    <div
      v-if="!isModalContent"
      class="quiz-header-inner__arrow-wrapper"
      @click.stop="handleCollapseAISlideGenerator()"
    >
      <aha-icon
        name="arrow-no-tail-white"
        width="17"
        height="17"
        viewBox="0 0 16 16"
        class="quiz-header-inner__arrow"
        :class="{'arrow-down': isAIGeneratorCollapsed}"
      />
      <span class="collapse-arrow__background"></span>
    </div>
    <aha-icon
      name="close"
      height="20"
      width="20"
      viewBox="0 0 24 24"
      class="cursor-pointer text-base-50 hover:text-base-0"
      @click="handleCloseModal()"
      v-if="isModalContent"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UserApi from '@/api/user'

export default {
  props: {
    isModalContent: {
      type: Boolean,
      default: false,
    },
    isSearchAIModalContentVisible: {
      type: Boolean,
      default: false,
    },
    isGeneratorContentVisible: {
      type: Boolean,
      default: false,
    },
    hasInputPrompt: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isArrowBackVisible() {
      return this.isGeneratorContentVisible && !this.isModalContent
    },
    isAIGeneratorCollapsed() {
      return this.currentUser && this.currentUser.rememberSettings &&
        this.currentUser.rememberSettings.isAIGeneratorCollapsed
    },
  },
  methods: {
    ...mapActions([
      'setCurrentUserAction',
    ]),

    backToChooseSlideType() {
      this.$emit('backToChooseSlideType')
    },

    async handleCollapseAISlideGenerator() {
      try {
        const payload = {
          isAIGeneratorCollapsed: !this.currentUser.rememberSettings.isAIGeneratorCollapsed,
        }
        this.setCurrentUserAction({
          ...this.currentUser,
          rememberSettings: {
            ...this.currentUser.rememberSettings,
            ...payload,
          },
        })
        await UserApi.updateSettings(payload)
      } catch (error) {
        //
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.quiz-header-inner__title {
  @apply flex items-center;
  .back-search {
    flex: 1;
    display: flex;
    align-items: center;
    .back-arrow__wrapper {
      @apply pr-3 cursor-pointer relative;
      .back-arrow__background {
        @apply opacity-0 transition-opacity duration-200;
      }
      &:hover {
        .back-arrow__background {
          @apply bg-primary-50 opacity-20 rounded-full absolute;
          width: 25px;
          height: 25px;
          left: -7px;
          top: 1px;
          z-index: 0;
        }
      }
    }
    .quiz-header-inner__title-no-prompt {
      font-size: 16px;
    }
    .quiz-header-inner__title-icon {
      @apply inline-block ml-1 mb-1;
    }
  }
}

.back-search {
  @apply text-xl font-bold text-base-0;
  padding-right: 16px;
}

.quiz-header-inner__arrow-wrapper {
  @apply absolute right-2 text-right;
  padding: 0.5rem 0.5rem 0.75rem 0.5rem;
  width: calc(100% - 50px);
  @apply cursor-pointer text-base-0 hover:text-base-30;
  .collapse-arrow__background {
    @apply opacity-0 transition-opacity duration-200;
  }
  &:hover {
    .collapse-arrow__background {
      @apply bg-primary-50 opacity-20 rounded-full absolute;
      width: 25px;
      height: 25px;
      right: 4.5px;
      top: 7px;
      z-index: 0;
    }
  }
  .quiz-header-inner__arrow {
    transition: transform 0.2s ease;
    transform: rotate(0);
    &.arrow-down {
      margin-bottom: -1px;
      transform: rotate(180deg);
    }
  }
}
</style>
